module.exports = __webpack_public_path__ + "static/slide-3-c8348483692144473469048285936b77.png";